import { render, staticRenderFns } from "./wayTestC.vue?vue&type=template&id=694d23e7&scoped=true&"
import script from "./wayTestC.vue?vue&type=script&lang=js&"
export * from "./wayTestC.vue?vue&type=script&lang=js&"
import style0 from "./wayTestC.vue?vue&type=style&index=0&id=694d23e7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694d23e7",
  null
  
)

export default component.exports